import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import Settings from "./Settings";
import Auth from "./Auth";
import Common from "./Common";
// import technicianReducer from "./";
import mrtReducer from "./mrt/index";
import modalityTypesReducer from "./ModalityTypes";

import adminReducer from "./admin/index";
import guildlibrarianReducer from "./guildlibrarian/index";
import misReducer from "./mis/index";
import ticketDetailsReducer from "./mis/ticketDetailsReducer";
import userModalReducer from "./userModalReducer";

import dashboardReducer from "./dashboardReducer";
import activityReducer from "./activityReducer";
import integratorReducer from "./integratorReducer";
import chatReducer from "./chatReducer";

import typistReducer from "./typist";
import groupsReducer from "./groupsReducer";
import templateReducer from "./templateReducer";
import diagramReducer from "./diagramReducer";

import groupadminReducer from "./groupadmin";
import worklistVisitsReducer from "./worklistVisitsReducer";

import userCasesReducer from "./UserCases";
import visitReport from "./visitReportReducer";

const reducers = combineReducers({
  routing: routerReducer,
  settings: Settings,
  auth: Auth,
  activity: activityReducer,
  dashboard: dashboardReducer,
  integrator: integratorReducer,
  commonData: Common,
  mrt: mrtReducer,
  modalityTypes: modalityTypesReducer,
  admin: adminReducer,
  guildlibrarian: guildlibrarianReducer,
  mis: misReducer,
  typist: typistReducer,
  diagramTemplates: diagramReducer,
  groupAdmin: groupadminReducer,
  ticket: ticketDetailsReducer,
  modal: userModalReducer,
  chat: chatReducer,
  groups: groupsReducer,
  templates: templateReducer,
  worklistVisits: worklistVisitsReducer,
  userCases: userCasesReducer,
  visitReport: visitReport
});

export default reducers;
